import React from 'react';
import classNames from 'classnames';
import NavigationBar from './NavigationBar';
import Navigation from './NavigationPanes';
import createWidget from '../../../utils/widget';
import Icon from '../common/Icon';

let firstRenderAfterRes = false;

class Nav extends React.Component {
  state = {
    items: {},
    activeItem: null,
    activeItemLvl2: null,
    paneLevel: 0,
    isOpen: false,
    isLoggedIn: null,
    name: null,
    snackbar: [],
    isAdmin: null,
    adminPage: null
  };

  componentDidMount() {
    const { items } = window.kvs.nav;
    const { isLoggedIn, isAdmin, adminPage, name, sessionExpires } = window.kvs.user;
    const { snackbar } = window.kvs;

    const activeItem = items.find(i => i.isDescendantActive);
    firstRenderAfterRes = true;

    this.setState({
      items: this.formatResponse(items),
      isLoggedIn,
      isAdmin,
      adminPage,
      name,
      sessionExpires,
      snackbar,
      activeItem,
      paneLevel: (!!activeItem && !!activeItem.children) | 0,
    });
    document.querySelector('.js-menu').addEventListener('click', () => {
      this.setState(state => ({ isOpen: !state.isOpen }));
    });
  }

  closeClickHandler = () => {
    this.setState({
      isOpen: false,
    });
  };

  formatResponse = data =>
    data.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

  setActiveItem = id => {
    this.setState(state => {
      if (typeof state.items[id] !== 'undefined') {
        return {
          activeItem: state.items[id],
        };
      }
      return {
        activeItemLvl2: state.items[state.activeItem.id].children.find(
          i => i.id === id,
        ),
      };
    });
  };

  setPaneLevel = level => {
    firstRenderAfterRes = false;

    this.setState({
      paneLevel: level,
    });
  };

  isPaneLevel = level => this.state.paneLevel === level;

  render() {
    const { isOpen, items, activeItem, activeItemLvl2, paneLevel, isLoggedIn, isAdmin, adminPage, name, sessionExpires, snackbar } = this.state;
    return (
      <div className={classNames('nav', '-stack', { '-open': isOpen })} style={snackbar && snackbar.length > 0 ? { top: '46px' } : {}}>
        <div className="nav__wrapper" style={snackbar && snackbar.length > 0 ? { top: '46px' } : {}}>
          <div className="nav__content">
            <NavigationBar open={isOpen} isLoggedIn={isLoggedIn} name={name} sessionExpires={sessionExpires} />
            <div className="nav__controls">
              <div className="nav__controlsClose nav__mobile__menu" onClick={this.closeClickHandler}>
                <div className="nav__mobile__menutext">
                  <p>Meny</p>
                </div>
                <Icon name="times" />
              </div>
            </div>
            <Navigation
              items={items}
              isAdmin={isAdmin}
              adminPage={adminPage}
              paneLevel={paneLevel}
              isPaneLevel={this.isPaneLevel}
              activeItem={activeItem}
              activeItemLvl2={activeItemLvl2}
              setActiveItem={this.setActiveItem}
              setPaneLevel={this.setPaneLevel}
              skipAnimate={firstRenderAfterRes}
            />
          </div>
        </div>
      </div >
    );
  }
}

const { render } = createWidget(Nav);

render(document.querySelector('.js-stack-navigation'));
